/* eslint-disable */
import { call, put, takeLatest } from "redux-saga/effects";
import { getActivity } from "api/my-work/activity";
import * as types from "redux/reducers/MyWork/actionTypes";
import { QueryServiceProps, PageSize } from "common/";

function* getListActivity(action) {
  try {
    yield put({
      type: types.UPDATE_LIST_ACTIVITY,
      activity: [],
    });
  } catch (error) {
    yield put({ type: types.SET_LOADING, loading: false });
    return Promise.reject(error);
  }
}

function* MyWork() {
  yield takeLatest(types.GET_ACTIVITY_REQUEST, getListActivity);
}

export default MyWork;
